<template>
    <div class="toc">
        <div class="title">
            <a class="toggle" @click.prevent="toggle">
                <i class="fas fa-list"></i>
            </a>
            <span>{{ ttt("Contents") }}</span>
        </div>
        <slot v-if="expanded"></slot>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onBeforeMount } from "vue";
import { i18n } from "@/services/i18n";

export default defineComponent({
    name: "toc",
    setup() {
        const expanded = ref(false);

        function toggle() {
            expanded.value = !expanded.value;
        }

        onBeforeMount(() => {
            i18n.add("ru", {
                Contents: "Содержание",
            });

            i18n.add("uk", {
                Contents: "Зміст",
            });

            i18n.add("pl", {
                Contents: "Treść",
            });
        });

        return {
            expanded,
            toggle,
            ttt: i18n.t,
        };
    },
});
</script>

<style scoped>
.toc {
    float: right;
    width: 50%;
    border: 1px solid #aaa;
    border-radius: 4px;
    box-shadow: 0 1px 1px rgb(0 0 0/5%);
    display: table;
    margin-bottom: 1em;
    padding: 10px;
    position: relative;
}

.title {
    font-size: 24px;
}

.toggle {
    float: right;
}

@media (max-width: 768px) {
    .toc {
        width: 100%;
    }
}
</style>
